import api from '../config/api'
import IAttachmentData from '../types/Attachment'

const upload = (data: IAttachmentData) => {
  let formData = new FormData()

  formData.append('feature', data.feature) //scenarios
  formData.append('object_id', String(data.object_id)) //scenario_id
  formData.append('field_name', data.field_name) //file_necessary_items
  formData.append('file', data.file)
  formData.append('file_type', data.file_type) //document
  formData.append('multiple', data.multiple) //false

  // Necessários quando field_name='debriefing_video': o backend usa
  // event_id/station_id/user_id para montar o caminho no GCS
  // (vod/{instancia}/{event}/{station}/{user}/) e retorna HTTP 400 se faltarem.
  // Sem isto, nenhum upload manual de vídeo chegava ao bucket.
  if (data.event_id !== undefined) formData.append('event_id', String(data.event_id))
  if (data.station_id !== undefined) formData.append('station_id', String(data.station_id))
  if (data.user_id !== undefined) formData.append('user_id', String(data.user_id))

  return api.post('attachments', formData)
}

const get = (feature: string, object_id: any, field_name: string, signal?: AbortSignal) => {
  return api.get(`/attachments/${feature}/${object_id}/${field_name}`, { signal })
}

const remove = (id: any) => {
  return api.delete(`/attachments/${id}`)
}

const AttachmentService = {
  upload,
  get,
  remove,
}

export default AttachmentService
